import { render, staticRenderFns } from "./ProgramCreate.vue?vue&type=template&id=6b130e3c&scoped=true"
import script from "./ProgramCreate.vue?vue&type=script&lang=js"
export * from "./ProgramCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b130e3c",
  null
  
)

export default component.exports